"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "../NextGen.module.scss";
import { useAuth } from "@/components/auth/Auth";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { NEXTGEN_CHAIN_ID } from "@/components/nextGen/nextgen_contracts";
import { formatNameForUrl, getBlurLink, getMagicEdenLink, getOpenseaLink } from "@/components/nextGen/nextgen_helpers";
import EthereumIcon from "@/components/user/utils/icons/EthereumIcon";
import UserCICAndLevel from "@/components/user/utils/UserCICAndLevel";
import YouOwnNftBadge from "@/components/you-own-nft-badge/YouOwnNftBadge";
import { ETHEREUM_ICON_TEXT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { NextGenCollection, NextGenToken } from "@/entities/INextgen";
import { areEqualAddresses, formatAddress, getRoyaltyImage, isNullAddress, numberWithCommas, printMintDate } from "@/helpers/Helpers";
import useCapacitor from "@/hooks/useCapacitor";
import { useIdentity } from "@/hooks/useIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { faFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { displayScore } from "./NextGenTokenProperties";
interface Props {
  collection: NextGenCollection;
  token: NextGenToken;
}
export default function NextgenTokenAbout(props) {
  const $ = _c(93);
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  const {
    connectedProfile
  } = useAuth();
  const [tdh, setTdh] = useState(0);
  let t0;
  if ($[0] !== props.token.owner) {
    t0 = {
      handleOrWallet: props.token.owner,
      initialProfile: null
    };
    $[0] = props.token.owner;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    profile
  } = useIdentity(t0);
  let t1;
  if ($[2] !== props.token.id) {
    t1 = () => {
      commonApiFetch({
        endpoint: `nextgen/tdh?token_id=${props.token.id}`
      }).then(result => {
        if (result.data.length === 1) {
          setTdh(result.data[0].boosted_tdh);
        }
      });
    };
    $[2] = props.token.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.token.id || $[5] !== props.token.owner) {
    t2 = [props.token.owner, props.token.id];
    $[4] = props.token.id;
    $[5] = props.token.owner;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  connectedProfile?.wallets;
  let t3;
  if ($[7] !== connectedProfile?.wallets || $[8] !== props.token.owner) {
    t3 = connectedProfile?.wallets?.some(w => areEqualAddresses(w.wallet, props.token.owner));
    $[7] = connectedProfile?.wallets;
    $[8] = props.token.owner;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const isOwner = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row><Col className="pb-3"><h3 className="mb-0">About</h3></Col></Row>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-color-h">Collection Token ID:</span>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== props.token.normalised_id) {
    t6 = <Row><Col className="pb-3 d-flex gap-1">{t5}<span>{props.token.normalised_id}</span></Col></Row>;
    $[12] = props.token.normalised_id;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-color-h">Contract Token ID:</span>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.token.id) {
    t8 = <Row><Col className="pb-3 d-flex gap-1">{t7}<span>{props.token.id}</span></Col></Row>;
    $[15] = props.token.id;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="font-color-h">Minted:</span>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== props.token.mint_date) {
    t10 = printMintDate(props.token.mint_date);
    $[18] = props.token.mint_date;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <Row><Col className="pb-3 d-flex gap-1">{t9}<span>{t10}</span></Col></Row>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="font-color-h">Mint Price:</span>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== props.token.mint_price) {
    t13 = props.token.mint_price ? <span className="d-flex align-items-center">{props.token.mint_price}<div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><EthereumIcon /></div></span> : "Free";
    $[23] = props.token.mint_price;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <Row><Col className="pb-3 d-flex gap-1">{t12}<span>{t13}</span></Col></Row>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="font-color-h">Collector:</span>;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== props.token.burnt || $[29] !== props.token.id || $[30] !== props.token.owner) {
    t16 = (props.token.burnt || isNullAddress(props.token.owner)) && <><FontAwesomeIcon icon={faFire} style={{
        height: "22px",
        color: "#c51d34"
      }} data-tooltip-id={`burnt-${props.token.id}`} /><Tooltip id={`burnt-${props.token.id}`} style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px"
      }}>Burnt</Tooltip></>;
    $[28] = props.token.burnt;
    $[29] = props.token.id;
    $[30] = props.token.owner;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== profile || $[33] !== props.token.owner) {
    t17 = profile?.level ? <Link href={`/${profile?.handle ?? props.token.owner}`} className="d-flex gap-2 decoration-hover-underline align-items-center"><UserCICAndLevel level={profile.level} /><span className="decoration-underline">{profile?.handle ?? profile?.display ?? formatAddress(props.token.owner)}</span></Link> : <Link href={`/${profile?.handle ?? props.token.owner}`}><span>{profile?.handle ?? profile?.display ?? formatAddress(props.token.owner)}</span></Link>;
    $[32] = profile;
    $[33] = props.token.owner;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== isOwner) {
    t18 = isOwner && <YouOwnNftBadge />;
    $[35] = isOwner;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t17 || $[39] !== t18) {
    t19 = <Row><Col className="pb-3 d-flex gap-2">{t15}<span className="d-flex gap-1 align-items-center">{t16}{t17}{t18}</span></Col></Row>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="font-color-h">Collector TDH:</span>;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  const t21 = Math.round((profile?.tdh ?? 0) * 100) / 100;
  let t22;
  if ($[42] !== t21) {
    t22 = numberWithCommas(t21);
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22) {
    t23 = <Row><Col className="pb-3 d-flex gap-2">{t20}<span className="d-flex gap-1 align-items-center">{t22}</span></Col></Row>;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== capacitor.isIos || $[47] !== country || $[48] !== props.token.blur_price || $[49] !== props.token.id || $[50] !== props.token.me_price || $[51] !== props.token.me_royalty || $[52] !== props.token.opensea_price || $[53] !== props.token.opensea_royalty) {
    t24 = (!capacitor.isIos || country === "US") && <Row><Col className="pb-3 d-flex flex-column"><span className="font-color-h">Listed:</span><span className="d-flex flex-column align-items-start gap-2 pt-1"><span><Link href={getOpenseaLink(NEXTGEN_CHAIN_ID, props.token.id)} target="_blank" rel="noopener noreferrer" className="d-flex gap-2 align-items-center decoration-none" data-tooltip-id={`opensea-${props.token.id}`}><Image unoptimized={true} className={styles.marketplace} src="/opensea.png" alt="opensea" width={24} height={24} />{props.token.opensea_price > 0 ? <span className="d-flex gap-2 align-items-center"><span className="d-flex align-items-center"><span>{props.token.opensea_price}</span><div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><EthereumIcon /></div></span>{props.token.opensea_royalty > 0 && <Image unoptimized={true} width={0} height={0} style={{
                  height: "25px",
                  width: "auto"
                }} src={`/${getRoyaltyImage(props.token.opensea_royalty / 100)}`} alt="pepe" className="cursor-pointer" />}</span> : "No"}</Link><Tooltip id={`opensea-${props.token.id}`} place="right" style={{
              backgroundColor: "#1F2937",
              color: "white",
              padding: "4px 8px"
            }}><Container><Row><Col>Opensea:{" "}{props.token.opensea_price > 0 ? `${props.token.opensea_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row>{props.token.opensea_price > 0 && <Row><Col>Royalties: {props.token.opensea_royalty}%</Col></Row>}</Container></Tooltip></span><span><Link href={getBlurLink(props.token.id)} target="_blank" rel="noopener noreferrer" className="d-flex gap-2 align-items-center decoration-none" data-tooltip-id={`blur-${props.token.id}`}><Image unoptimized={true} className={styles.marketplace} src="/blur.png" alt="blur" width={24} height={24} />{props.token.blur_price > 0 ? <span className="d-flex gap-2 align-items-center"><span className="d-flex align-items-center"><span>{props.token.blur_price}</span><div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><EthereumIcon /></div></span></span> : "No"}</Link><Tooltip id={`blur-${props.token.id}`} place="right" style={{
              backgroundColor: "#1F2937",
              color: "white",
              padding: "4px 8px"
            }}><Container><Row><Col>Blur:{" "}{props.token.blur_price > 0 ? `${props.token.blur_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row></Container></Tooltip></span><span><Link href={getMagicEdenLink(props.token.id)} target="_blank" rel="noopener noreferrer" className="d-flex gap-2 align-items-center decoration-none" data-tooltip-id={`magic-eden-${props.token.id}`}><Image unoptimized={true} className={styles.marketplace} src="/magiceden.png" alt="magiceden" width={24} height={24} />{props.token.me_price > 0 ? <span className="d-flex gap-2 align-items-center"><span className="d-flex align-items-center"><span>{props.token.me_price}</span><div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><EthereumIcon /></div></span>{props.token.me_royalty > 0 && <Image unoptimized={true} width={0} height={0} style={{
                  height: "25px",
                  width: "auto"
                }} src={`/${getRoyaltyImage(props.token.me_royalty / 100)}`} alt="pepe" className="cursor-pointer" />}</span> : "No"}</Link><Tooltip id={`magic-eden-${props.token.id}`} place="right" style={{
              backgroundColor: "#1F2937",
              color: "white",
              padding: "4px 8px"
            }}><Container><Row><Col>Magic Eden:{" "}{props.token.me_price > 0 ? `${props.token.me_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row>{props.token.me_price > 0 && <Row><Col>Royalties: {props.token.me_royalty}%</Col></Row>}</Container></Tooltip></span></span></Col></Row>;
    $[46] = capacitor.isIos;
    $[47] = country;
    $[48] = props.token.blur_price;
    $[49] = props.token.id;
    $[50] = props.token.me_price;
    $[51] = props.token.me_royalty;
    $[52] = props.token.opensea_price;
    $[53] = props.token.opensea_royalty;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <span className="font-color-h">Collection:</span>;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== props.collection.name) {
    t26 = formatNameForUrl(props.collection.name);
    $[56] = props.collection.name;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  const t27 = `/nextgen/collection/${t26}`;
  let t28;
  if ($[58] !== props.collection.name || $[59] !== t27) {
    t28 = <Row><Col className="pb-3 d-flex gap-1">{t25}<span><Link href={t27}>{props.collection.name}</Link></span></Col></Row>;
    $[58] = props.collection.name;
    $[59] = t27;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <span className="font-color-h">Artist:</span>;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  const t30 = `/${props.collection.artist_address}`;
  let t31;
  if ($[62] !== props.collection.artist || $[63] !== t30) {
    t31 = <Row><Col className="pb-3 d-flex gap-1">{t29}<span><Link href={t30}>{props.collection.artist}</Link></span></Col></Row>;
    $[62] = props.collection.artist;
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <span className="font-color-h">TDH Rate:</span>;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  const t33 = Math.round(props.token.hodl_rate * 100) / 100;
  let t34;
  if ($[66] !== t33) {
    t34 = numberWithCommas(t33);
    $[66] = t33;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== t34) {
    t35 = <span>{t34}</span>;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <span className="font-color-h">TDH:</span>;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  const t37 = Math.round(tdh * 100) / 100;
  let t38;
  if ($[71] !== t37) {
    t38 = numberWithCommas(t37);
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t38) {
    t39 = <span>{t38}</span>;
    $[73] = t38;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] !== t35 || $[76] !== t39) {
    t40 = <Row><Col className="pb-3 d-flex gap-1">{t32}{t35}  |  {t36}{t39}</Col></Row>;
    $[75] = t35;
    $[76] = t39;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <span className="font-color-h">Image Licence:</span>;
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  let t42;
  if ($[79] !== props.collection.licence) {
    t42 = <Row><Col className="pb-3 d-flex gap-1">{t41}<span>{props.collection.licence}</span></Col></Row>;
    $[79] = props.collection.licence;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== t11 || $[82] !== t14 || $[83] !== t19 || $[84] !== t23 || $[85] !== t24 || $[86] !== t28 || $[87] !== t31 || $[88] !== t40 || $[89] !== t42 || $[90] !== t6 || $[91] !== t8) {
    t43 = <Container className="no-padding">{t4}{t6}{t8}{t11}{t14}{t19}{t23}{t24}{t28}{t31}{t40}{t42}</Container>;
    $[81] = t11;
    $[82] = t14;
    $[83] = t19;
    $[84] = t23;
    $[85] = t24;
    $[86] = t28;
    $[87] = t31;
    $[88] = t40;
    $[89] = t42;
    $[90] = t6;
    $[91] = t8;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  return t43;
}
export function TraitScore(props) {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="font-smaller font-color-h">Score</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.score) {
    t1 = displayScore(props.score);
    $[1] = props.score;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="no-wrap d-flex align-items-center">{t0} {t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="font-color-h">|</span>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-smaller font-color-h">Rank</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.rank) {
    t5 = props.rank.toLocaleString();
    $[7] = props.rank;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="no-wrap d-flex align-items-center">{t4} #{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <span className="d-flex flex-column"><span className="d-flex gap-2">{t2}{t3}{t6}</span></span>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}